import { AxiosPostUrl } from "../../functions/axiosfunctions";

export function RemoveEtude(
  data: Object,
  cb = function (reponse: any) {}
) {
  AxiosPostUrl(
    "/administration/etude/remove",
    data,
    (reponse) => {
      if (reponse) {
        cb(reponse);
      } else {
        cb({
          success: false,
          data: {},
          msg: "Erreur survenue !",
        });
      }
    },
    function (reponse) {
      cb({
        success: false,
        data: {},
        msg: "Erreur survenue !",
      });
    }
  );
}
